import {
  Box,
  Flex,
  HStack,
  Table,
  TableContainer,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { MdReadMore } from "react-icons/md";
import CreateReturnToShelf from "../Components/CreateReturnToShelf";
import Pagination from "../Components/Pagination";
import Preloader from "../Components/Preloader";
import ScnDetails from "../Components/ScnDetails";
import TableRow from "../Components/TableRow";
import MainLayout from "../Layouts/Index";
import { AllSCN, AllSraProduct } from "../Utils/ApiCalls";
import Seo from "../Utils/Seo";
import { configuration } from "../Utils/config";
import SearchComponent from "../Components/SearchComponent";

export default function ReturnToStore() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [OpenModal, setOpenModal] = useState(false);
  const [SingleData, setSingleData] = useState([]);
  const [Data, setData] = useState([]);
  const [SearchText, setSearchText] = useState("");

  const [CurrentPage, setCurrentPage] = useState(1);
  const [PostperPage, setPostperPage] = useState(configuration.sizeperpage);
  const [PreLoader, setPreLoader] = useState(true);

  //get current post

  const indexOfLastSra = CurrentPage * PostperPage;
  const indexOfFirstSra = indexOfLastSra - PostperPage;
  const currentData = Data.slice(indexOfFirstSra, indexOfLastSra);
  //change page
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const ReturntoStore = () => {
    onOpen();
  };

  const AllStoreCreditNote = async () => {
    let result = await AllSCN();

    console.log("allscn", result);

    if (result.status == true) {
      setData(result.queryresult.scndetails);
      setPreLoader(false);
    }
  };

  const ReadMore = (id) => {
    let singleInfo = Data.filter((item, i) => {
      return item._id === id;
    });
    setOpenModal(true);
    setSingleData(singleInfo);
  };

  useEffect(() => {
    AllStoreCreditNote();
  }, [isOpen]);
  return (
    <MainLayout>
      {PreLoader && <Preloader />}
      <Seo title="Return to Store" description="IMS Return to store " />

      <Flex justifyContent={"space-between"} flexWrap="wrap" fontWeight={"500"}>
        <HStack
          onClick={ReturntoStore}
          cursor={"pointer"}
          _hover={{ color: "blue.blue600" }}
        >
          <Box>
            <AiOutlinePlus />
          </Box>
          <Text>Store Credit Note</Text>
        </HStack>
        <Text textTransform="capitalize">
          Total Returned Products - {Data.length}
        </Text>
      </Flex>

      <SearchComponent
        SearchText={SearchText}
        setSearchText={(e) => setSearchText(e.target.value)}
        Keywords={"ProductName, Raised by, returned by, Product Shelf"}
      />

      <Box
        display={"block"}
        alignItems="flex-start"
        w={"100%"}
        height="70vh"
        minH={"70vh"}
        overflow="auto"
        _hover={{ overflow: "auto" }}
        bg="blue.blue200"
        mt="32px"
        rounded={"8px"}
      >
        <TableContainer w={"100%"} mt="32px" overflowX="auto" color="#fff">
          <Table variant="simple" size="sm" overflowX="auto">
            <Thead>
              <Tr>
                <Th color="#fff">S/N</Th>
                <Th color="#fff">Product name</Th>
                <Th color="#fff">Price</Th>
                <Th color="#fff">Qty Returned</Th>
                <Th color="#fff">Returnee Dept</Th>
                <Th color="#fff">Status</Th>
                <Th color="#fff">Read more</Th>
              </Tr>
            </Thead>
            
          
            <Tbody>
              {SearchText === "" ? (
                currentData.map((item, i) => (
                  <TableRow
                    key={i}
                    sn={i + 1}
                    type="returnToStore"
                    productName={item.shelfid?.productname}
                    price={item.price?.toLocaleString()}
                    qty={item.qtyreturned?.toLocaleString()}
                    dept={item.returneedepartment || " "}
                    status={item.status || " "}
                    onClick={() => ReadMore(item._id)}
                  />
                ))
              ) : SearchText !== "" &&
                Data.filter(
                  (item) =>
                    item.shelfid?.productname
                      .toLowerCase()
                      .includes(SearchText.toLowerCase()) ||
                      item.shelfid?.productshelfid.includes(SearchText)
                      
                      ||
                    item.raiseby
                      .toLowerCase()
                      .includes(SearchText.toLowerCase()) ||
                    item.returnby
                      .toLowerCase()
                      .includes(SearchText.toLowerCase())
                ).length > 0 ? (
                Data.filter(
                  (item) =>
                    item.shelfid?.productname
                      .toLowerCase()
                      .includes(SearchText.toLowerCase()) ||
                      item.shelfid?.
                      productshelfid.includes(SearchText)
                      
                      ||
                    item.raiseby
                      .toLowerCase()
                      .includes(SearchText.toLowerCase()) ||
                    item.returnby
                      .toLowerCase()
                      .includes(SearchText.toLowerCase())
                ).map((item, i) => (
                  <TableRow
                    key={i}
                    sn={i + 1}
                    type="returnToStore"
                    productName={item.shelfid?.productname}
                    price={item.price?.toLocaleString()}
                    qty={item.qtyreturned?.toLocaleString()}
                    dept={item.returneedepartment || " "}
                    status={item.status || " "}
                    onClick={() => ReadMore(item._id)}
                  />
                ))
              ) : (
                <Text textAlign={"right"} mt="32px" color="#ddd">
                  *--No result found--*
                </Text>
              )}
            </Tbody>
          </Table>
        </TableContainer>

        <Pagination
          postPerpage={PostperPage}
          currentPage={CurrentPage}
          totalPosts={Data.length}
          paginate={paginate}
        />
      </Box>

      <CreateReturnToShelf state="scn" isOpen={isOpen} onClose={onClose} />
      <ScnDetails
        isOpen={OpenModal}
        onClose={() => setOpenModal(!OpenModal)}
        singleData={SingleData}
      />
    </MainLayout>
  );
}
